import * as React from 'react'
import {Box, Typography} from "@mui/material";
import { translateCountryName } from "@ui-seeker/utils"

import {NotAllowedBlock, RetailerBlock} from "@components";


export default function retailerColumn() {
    return [{
        name: 'country', label: 'Country',
        options: {
            display: 'excluded',
            customBodyRowRender: v => translateCountryName(v)
        }
    },{
        name: 'siteName', label: 'Retailer',
        options: {
            headerAlign: 'center',
            customBodyRowRenderLite: (value, { country, siteURL, siteID }) => {
                return <Box display="flex" justifyContent="center">
                    {!siteID && <NotAllowedBlock />}
                    {!!siteID && <Box>
                        <RetailerBlock
                            retailer={value}
                            country={country}
                            siteURL={siteURL}
                        />
                        <Typography variant='subtitle2'>
                            {'Site ID : ' + siteID}
                        </Typography>
                    </Box>}
                </Box>
            }
        }
    }]
}